module.exports = __webpack_public_path__ + "static/media/welcomePage.58da306e.svg";